<div [ngClass]="{ 'wrapper wrapper-content': !task }">
    <div class="container-fluid  ng-scope" style="padding-bottom: 25px;">
        <!-- ZONA DE FORMULARIO -->
        <!--<ng-container *ngIf="isLoaded()">
            <div class="row  justify-content-center w-100">
                <div class="col-6">

                    <ul class="stepper stepper-horizontal"
                        *ngIf="!this.isApportioned() && (this.hasNextStep() || this.hasPreviousStep())">

                        <li [ngClass]="currentStep == step.value ? 'completed' : null"
                            *ngFor="let step of stepDefinition.steps">
                            <a *ngIf="hasPreviousStep()" (click)="previousStep()"
                                title="{{'ProcurementProject.changeStep'|translate}}">
                                <span class="circle">{{ step.value + 1 }}</span>
                                <span class="label">{{ step.label }}</span>
                            </a>
                            <a *ngIf="hasNextStep()" (click)="nextStep()"
                                title="{{'ProcurementProject.changeStep'|translate}}">
                                <span class="circle">{{ step.value + 1 }}</span>
                                <span class="label">{{ step.label }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </ng-container>-->
        <div>
            <formPlyca #formPlycaRef [formConfig]="formConfig" [manageWaitService]="false"></formPlyca>
        </div>
        <p-dialog [(visible)]="showGoToLotSelection" [showHeader]="true" header="Ir al Lote" [closeOnEscape]="true"
            [modal]=" true" [draggable]="false" [appendTo]="'body'" [responsive]="true" [focusOnShow]="true">
            <!--<div class="container-fluid pb-5">
                <div class="row">
                    <div class="col-12 m-xs font-weight-bold">
                        {{'ProcurementProjectAYMAD.GoToLot' | translate }}
                    </div>
                </div>
            </div>-->
            <p-menu #lotMenu [model]="lotMenuItems" class="goToLot">
            </p-menu>
        </p-dialog>
        <p-dialog [(visible)]="showPartialLotCopy" [showHeader]="true" header="Copia parcial de lotes"
            [closeOnEscape]="true" [modal]=" true" [draggable]="false" [appendTo]="'body'" [responsive]="true"
            [focusOnShow]="true" [style]="{'width':'50%'}">
            <div class="container-fluid pb-5">
                <div class="row">
                    <div class="col-12 m-xs">
                        Seleccione lote del que copiar la información
                    </div>
                    <div class="col-12 m-xs">
                        <p-dropdown [options]="lotsToCopy" [(ngModel)]="selectedLotToCopy" optionLabel="description"
                            dataKey="identifier">
                            <ng-template let-selectedLot pTemplate="selectedItem">
                                {{selectedLot.lotNumber}} - {{selectedLot.description}}
                            </ng-template>
                            <ng-template let-lot2Copy pTemplate="item">
                                {{lot2Copy.lotNumber}} - {{lot2Copy.description}}
                            </ng-template>
                        </p-dropdown>
                    </div>

                    <div class="col-12 m-xs">
                        <div *ngFor="let option of copyLotOptions" class="d-flex align-items-center">
                            <span (click)="executeHelpPartialCopy(option)"><i
                                    class="fa fa-info-circle text text-info m-l-sm" style="cursor:pointer;"
                                    aria-hidden="true"></i></span>
                            <div class="ml-2">
                                <p-checkbox name="copyLotOptions" [value]="option" [(ngModel)]="selectedCopyOptions"
                                    [label]="translateService.instant('ProcurementProjectAYMAD.Lot.CopyOptions.' + option)"
                                    ngClass="d-block m-t-xs">
                                </p-checkbox>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 d-flex justify-content-center m-b-md m-t-md">
                        <div class="btn-group-xs">
                            <button class="m-l-sm btn btn-primary btn-sm" appNoDblClick (click)="executePartialCopy()"
                                type="button" [disabled]="(selectedCopyOptions?.length > 0) ? undefined : 'disabled'">
                                <i class="fa fa-check"></i> {{'General.accept' | translate}}</button>
                            <button class="m-l-sm btn btn-secondary btn-sm" appNoDblClick
                                (click)="showPartialLotCopy = false" type="button">
                                <i class="fas fa-times"></i> {{'General.close' | translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </p-dialog>
    </div>
</div>
<ng-template #budgetSummaryTemplate>
    <plyca-projectBudgetSummary [project]="this.dossier"></plyca-projectBudgetSummary>
</ng-template>
<ng-template #budgetSummaryAMTemplate>
    <plyca-projectBudgetSummaryAM [project]="this.dossier"></plyca-projectBudgetSummaryAM>
</ng-template>